'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var errCode = require('err-code');

var multibase = require('multibase');

var _require = require('streaming-iterables'),
    parallelMap = _require.parallelMap,
    collect = _require.collect;

var pipe = require('it-pipe');

var _require2 = require('../../utils'),
    resolvePath = _require2.resolvePath;

var _require3 = require('./pin-manager'),
    PinTypes = _require3.PinTypes;

var PIN_RM_CONCURRENCY = 8;

module.exports = function (_ref) {
  var pinManager = _ref.pinManager,
      gcLock = _ref.gcLock,
      dag = _ref.dag;
  return /*#__PURE__*/function () {
    var _rm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(paths, options) {
      var recursive, cids, release, results;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              options = options || {};
              recursive = options.recursive !== false;

              if (!(options.cidBase && !multibase.names.includes(options.cidBase))) {
                _context2.next = 4;
                break;
              }

              throw errCode(new Error('invalid multibase'), 'ERR_INVALID_MULTIBASE');

            case 4:
              _context2.next = 6;
              return resolvePath(dag, paths);

            case 6:
              cids = _context2.sent;
              _context2.next = 9;
              return gcLock.readLock();

            case 9:
              release = _context2.sent;
              _context2.prev = 10;
              _context2.next = 13;
              return pipe(cids, parallelMap(PIN_RM_CONCURRENCY, /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid) {
                  var _yield$pinManager$isP, pinned, reason;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return pinManager.isPinnedWithType(cid, PinTypes.all);

                        case 2:
                          _yield$pinManager$isP = _context.sent;
                          pinned = _yield$pinManager$isP.pinned;
                          reason = _yield$pinManager$isP.reason;

                          if (pinned) {
                            _context.next = 7;
                            break;
                          }

                          throw new Error("".concat(cid, " is not pinned"));

                        case 7:
                          if (!(reason !== PinTypes.recursive && reason !== PinTypes.direct)) {
                            _context.next = 9;
                            break;
                          }

                          throw new Error("".concat(cid, " is pinned indirectly under ").concat(reason));

                        case 9:
                          if (!(reason === PinTypes.recursive && !recursive)) {
                            _context.next = 11;
                            break;
                          }

                          throw new Error("".concat(cid, " is pinned recursively"));

                        case 11:
                          return _context.abrupt("return", cid);

                        case 12:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }()), collect);

            case 13:
              results = _context2.sent;
              // update the pin sets in memory
              results.forEach(function (cid) {
                if (recursive && pinManager.recursivePins.has(cid.toString())) {
                  pinManager.recursivePins.delete(cid.toString());
                } else {
                  pinManager.directPins.delete(cid.toString());
                }
              }); // persist updated pin sets to datastore

              _context2.next = 17;
              return pinManager.flushPins();

            case 17:
              return _context2.abrupt("return", results.map(function (cid) {
                return {
                  cid: cid
                };
              }));

            case 18:
              _context2.prev = 18;
              release();
              return _context2.finish(18);

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[10,, 18, 21]]);
    }));

    function rm(_x, _x2) {
      return _rm.apply(this, arguments);
    }

    return rm;
  }();
};